// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__pxQEc","header":"MergedInvoice_header__27bKE"};